// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"91239d12","53":"c88a5f81","359":"5b364e61","393":"f1ccf1e8","408":"485789f0","411":"420bad83","570":"710c9a30","621":"3bb7a074","660":"8159e6b6","775":"d2619058","887":"d61b486e","931":"474a819f"}[chunkId] + ".chunk.js";
};